# Generated by https://pagedraw.io/pages/1470
React = require 'react'
createReactClass = require 'create-react-class'


module.exports = Footer = createReactClass {
    displayName: 'Footer'
    render: ->
        React.createElement("div", {"className": "footer-footer-0"},
          React.createElement("style", {"dangerouslySetInnerHTML": (__html: """
              @import url('https://fonts.googleapis.com/css?family=Lato:');
              
              .footer-footer-0 {
                  display: flex;
                  flex-direction: column;
                  flex-grow: 1;
                  padding-top: 33px;
                  padding-bottom: 17px;
              }
              
              .footer-0 {
                  display: flex;
                  flex-shrink: 0;
                  padding-right: 2px;
              }
              
              .footer-hr-9 {
                  width: 1118px;
                  height: 1px;
                  flex-shrink: 0;
                  background: #E4E4E4;
              }
              
              .footer-1 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 12px;
                  padding-left: 871px;
                  padding-right: 6px;
              }
              
              .footer-1-0 {
                  display: flex;
                  flex-direction: column;
                  padding-top: 29px;
                  padding-bottom: 7px;
              }
              
              .footer-1-0-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .footer-text_2 {
                  flex-shrink: 0;
                  font-family: "Lato", sans-serif;
                  color: rgba(16, 16, 16, 0.87);
                  font-size: 12px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: none;
                  text-align: right;
                  word-wrap: break-word;
                  padding-right: 0.171875px;
              }
              
              .footer-1-0-1 {
                  display: flex;
                  flex-shrink: 0;
                  margin-top: 3px;
                  padding-left: 115px;
              }
              
              .footer-text_22 {
                  flex-shrink: 0;
                  font-family: "Lato", sans-serif;
                  color: rgb(37, 37, 37);
                  font-size: 10px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: none;
                  text-align: right;
                  word-wrap: break-word;
                  padding-right: 0.515625px;
              }
              
              .footer-image_4 {
                  width: 49px;
                  height: 66px;
                  flex-shrink: 0;
                  margin-left: 2px;
                  border-width: 0px;
              }
              
              * {
                  box-sizing: border-box;
              }
              
              body {
                  margin: 0;
              }
              
              button:hover {
                  cursor: pointer;
              }
              
              a {
                  text-decoration: none;
                  color: inherit;
              }
              
              .pd-onhover-parent >.pd-onhover {
                  display: none;
              }
              
              .pd-onhover-parent:hover > * {
                  display: none;
              }
              
              .pd-onhover-parent:hover > .pd-onhover {
                  display: flex;
              }
              
              .pd-onactive-parent > .pd-onactive {
                  display: none;
              }
              
              .pd-onactive-parent:active > * {
                  display: none;
              }
              
              .pd-onactive-parent:active > .pd-onactive {
                  display: flex;
              }
              
              .pd-onactive-parent.pd-onhover-parent:active > .pd-onhover {
                  display: none;
              }
          """)}),  
          React.createElement("div", {"className": "footer-0"},
              React.createElement("div", {"className": "footer-hr-9"}) 
          ),
          React.createElement("div", {"className": "footer-1"},
              React.createElement("div", {"className": "footer-1-0"},
                  React.createElement("div", {"className": "footer-1-0-0"},
                      React.createElement("div", {"className": "footer-text_2"}, """
                          Making programming more powerful
""")
                  ),
                  React.createElement("div", {"className": "footer-1-0-1"},
                      React.createElement("div", {"className": "footer-text_22"}, ("©2018 Pagedraw"))
                  )
              ),
              React.createElement("img", {"src": "https://complex-houses.surge.sh/dcc8b8a1-72a3-4eeb-b397-cf0306fcf8fd/sit.png", "className": "footer-image_4"}) 
          )
      )
}



// WEBPACK FOOTER //
// ./node_modules/cjsx-loader!./src/pagedraw/footer.cjsx